const capitalize = (s: string) => s?.charAt(0)?.toUpperCase() + s?.slice(1)?.toLowerCase();

export default capitalize;
